import FloatingBadge from './FloatingBadge'

export default FloatingBadge
